import { render, staticRenderFns } from "./TenderConfirmation.vue?vue&type=template&id=96c8ed7e&scoped=true"
import script from "./TenderConfirmation.vue?vue&type=script&lang=js"
export * from "./TenderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./TenderConfirmation.vue?vue&type=style&index=0&id=96c8ed7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c8ed7e",
  null
  
)

export default component.exports